// 2026 的开幕式和主论坛同属 main，按中文标题区分；环境间 id 不一致，不能按 id 硬编码。
export const isOpening = item => (item.title || '').includes('开幕式')
export const hasStaffs = item => (item.staffs || []).length > 0

export const getForumSpeakerVisibility = (list = []) => {
  const agendas = list || []
  return {
    opening: agendas.some(item => item.type === 'main' && isOpening(item) && hasStaffs(item)),
    main: agendas.some(item => item.type === 'main' && !isOpening(item) && hasStaffs(item)),
    topic: agendas.some(item => item.type === 'topic' && hasStaffs(item)),
  }
}
